import styled, { css } from 'styled-components';
import { compareColors } from '../../../constants';

type DotsWrapperProps = {
  width: number;
};

export const DotsWrapper = styled.div<DotsWrapperProps>(
  props => css`
    position: relative;
    overflow: hidden;
    margin: auto;
    width: ${props.width}px;
    max-width: 100vw;
  `
);

type DotsProps = {
  translateX: number;
};

export const Dots = styled.ul<DotsProps>(
  props => css`
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    transform: translateX(${props.translateX}px);
    transition: transform 0.3s ease-out;
  `
);

type DotProps = {
  highlighted?: boolean;
  small?: boolean;
};

export const Dot = styled.span<DotProps>(
  props => css`
    transition: transform 0.2s ease-out;
    line-height: 0;
    display: block;
    background: ${props.theme.colors.base300};
    border-radius: 50%;

    ${props.highlighted &&
      css`
        background: ${compareColors.separator};
        transform: scale(1.5, 1.5);
      `}

    ${props.small &&
      css`
        transform: scale(0.5, 0.5);
      `}
  `
);

type DotListItemProps = {
  width: number;
};

const nTimesSmallerSize = 3;

export const DotListItem = styled.li<DotListItemProps>(
  props => css`
    min-width: ${props.width}px;
    width: ${props.width}px;
    height: ${props.width}px;
    display: flex;
    justify-content: center;
    align-items: center;

    ${Dot} {
      width: ${props.width / nTimesSmallerSize}px;
      height: ${props.width / nTimesSmallerSize}px;
    }
  `
);
